module.exports = __webpack_public_path__ + "img/location-pin.b5ab1971.svg";